import React from "react";

const NewsSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="8"
      viewBox="0 0 12 8"
    >
      <path
        id="newspaper-regular"
        d="M11.5,64H2.333a1,1,0,0,0-.943.667H.5a.5.5,0,0,0-.5.5v5.667A1.167,1.167,0,0,0,1.167,72H11.5a.5.5,0,0,0,.5-.5v-7A.5.5,0,0,0,11.5,64ZM1,70.833V65.667h.333v5.167a.167.167,0,1,1-.333,0ZM11,71H2.321a1.176,1.176,0,0,0,.012-.167V65H11ZM3.583,68.5H6.417a.25.25,0,0,0,.25-.25v-2a.25.25,0,0,0-.25-.25H3.583a.25.25,0,0,0-.25.25v2A.25.25,0,0,0,3.583,68.5Zm.583-1.667H5.833v.833H4.167ZM3.333,69.75v-.5a.25.25,0,0,1,.25-.25H6.417a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H3.583A.25.25,0,0,1,3.333,69.75Zm4,0v-.5a.25.25,0,0,1,.25-.25H9.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H7.583A.25.25,0,0,1,7.333,69.75Zm0-3v-.5a.25.25,0,0,1,.25-.25H9.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H7.583A.25.25,0,0,1,7.333,66.75Zm0,1.5v-.5a.25.25,0,0,1,.25-.25H9.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H7.583A.25.25,0,0,1,7.333,68.25Z"
        transform="translate(0 -64)"
        fill="#28d0c9"
      />
    </svg>
  );
};

export default NewsSVG;
